/**
 * Styles para /administracao/importacoes.
 */
import styled from "styled-components";

import { getToneTokens } from "../../../styles/shared";

export const Card = styled.section`
  background: ${({ theme }) => theme.surface};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionTitle = styled.h3`
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.textSecondary};
`;

export const FileDrop = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
  border: 2px dashed ${({ theme }) => theme.border};
  border-radius: 12px;
  cursor: pointer;
  color: ${({ theme }) => theme.textSecondary};
  background: ${({ theme }) => theme.surfaceAlt};
  transition: border-color 0.18s ease, color 0.18s ease;

  &:hover {
    border-color: ${({ theme }) => theme.accent};
    color: ${({ theme }) => theme.accent};
  }

  input[type="file"] {
    display: none;
  }

  strong {
    font-weight: 600;
    color: ${({ theme }) => theme.textPrimary};
  }
`;

export const Row = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

export const Select = styled.select`
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textPrimary};
  font-size: 0.88rem;
`;

export const PrimaryButton = styled.button`
  background: ${({ theme }) => theme.accent};
  color: #fff;
  border: 0;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  background: transparent;
  color: ${({ theme }) => theme.textPrimary};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.85rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background: ${({ theme }) => theme.surfaceAlt};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ResultGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px;
`;

export const ResultCard = styled.div`
  border-radius: 10px;
  border: 1px solid
    ${({ theme, $tone = "default" }) => getToneTokens(theme, $tone).border};
  background: ${({ theme, $tone = "default" }) => getToneTokens(theme, $tone).background};
  color: ${({ theme, $tone = "default" }) => getToneTokens(theme, $tone).text};
  padding: 12px 14px;
`;

export const ResultLabel = styled.div`
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.75;
`;

export const ResultValue = styled.div`
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.1;
  margin-top: 2px;
`;

export const TableWrapper = styled.div`
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  /* Bugfix #13: overflow-x clip (nao auto-promove overflow-y) */
  overflow-x: clip;
`;

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 0.85rem;

  th,
  td {
    text-align: left;
    padding: 8px 10px;
    border-bottom: 1px solid ${({ theme }) => theme.border};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  th {
    font-size: 0.68rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: ${({ theme }) => theme.textSecondary};
    font-weight: 600;
    background: ${({ theme }) => theme.surfaceAlt};
  }
`;

export const Pill = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  background: ${({ theme, $tone = "neutral" }) => getToneTokens(theme, $tone).background};
  color: ${({ theme, $tone = "neutral" }) => getToneTokens(theme, $tone).text};
  border: 1px solid ${({ theme, $tone = "neutral" }) => getToneTokens(theme, $tone).border};
`;

export const ErrorBox = styled.div`
  padding: 12px 14px;
  border-radius: 8px;
  background: ${({ theme }) => theme.dangerSurface};
  color: ${({ theme }) => theme.dangerText};
  border: 1px solid ${({ theme }) => theme.dangerBorder};
  font-size: 0.85rem;
`;

export const HelpText = styled.p`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.textSecondary};
  line-height: 1.5;
  margin: 0;
`;
